function teamNameWithDivision(team) {
  let name;
  let divisionName;

  name = team.name;
  divisionName = team.pool && team.pool.division ? team.pool.division.name : null;

  if (divisionName) {
    return `${name} (${divisionName})`;
  } else {
    return name;
  }
}

export {
  teamNameWithDivision
};



// WEBPACK FOOTER //
// ./src/js/filters/TeamFilters.js